/*
 * Project: bellcloud
 * File: packages/types/device/lite/batteryState.ts
 * Author: SWAN
 * Created: 2025-11-25
 * Description: Battery State
 */

export const BATTERY_STATE_MAP: Record<number, string> = {
  0: 'Low battery',
  1: '0~5%',
  2: '5~25%',
  3: '25~50%',
  4: '50~75%',
  5: '75%~100% ',
};
